import * as React from "react"
import styled from "styled-components"
import { theme } from "../theme"
import Body from "./typography/Body"

interface Props {
  number: number
}

const NumberContainer = styled.div`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors.greyDark};
`

const NumberNotification: React.FunctionComponent<Props> = ({ number }) => {
  return (
    <NumberContainer>
      <Body color={theme.colors.white}>{number}</Body>
    </NumberContainer>
  )
}

export default NumberNotification
